module.exports = __webpack_public_path__ + "img/organ-docs.5dbf3bc.svg";